export const HIGHLIGHT_TRACKING_EVENT_NAME = 'highlight-slide-change';
